module.exports = __webpack_public_path__ + "media/bootstrap-icons/pin-fill-ab1d0005.svg";